
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"120","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M3.33 60h113.33v48H3.33z"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M27.5 108l7-11h51l7 11M34.76 97V59.73M85.24 97V59.73M21.14 60.2V45.68h13.52V60.2M85.34 60.2V45.68h13.52V60.2M30.27 45.68h59.46M85.24 45.24a25.24 25.24 0 10-50.48 0M64.1 97V71h11v26M55.9 97V71h-11v26"}})])
          )
        }
      }
    